import React, { useState } from 'react'
import { Button } from "antd"
import { UserAddOutlined } from '@ant-design/icons';
import ModifyUser from './ModifyUser';
import CreateUser from './CreateUser';
import './addUser.css'

function AddUser() {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [updateList, setUpdateList] = useState<boolean>(false)

  const handleAdd = () => {
    setShowModal(true)
  }

  return (
    <div className='add-user-main'>
      <CreateUser setShowModal={setShowModal} showModal={showModal} setUpdateList={setUpdateList} />
      <h1>Liste des utilisateurs</h1>
      <div>
        <div className='add-user-div'>
          <Button className='add-user-button' onClick={handleAdd}>
            <UserAddOutlined />
            Ajouter un collaborateur
          </Button>
        </div>
        <ModifyUser setUpdateList={setUpdateList} updateList={updateList} />
      </div>
    </div>
  )
}
export default AddUser